<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on }">
                <v-btn
                    text
                    class="text--main-yellow"
                    v-on="on"
                >
                    {{$t('sortBy')}}
                    <v-icon>swap_vert</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item
                    v-for="item in sortData"
                    :key="item.title"
                    @click="updateSort(item.value, item.order)"
                >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

export default {
    name: "ProductSort",
    computed: {
        sortData() {
            return this.$store.state.baseInfo.sortProducts;
        }
    },
    methods: {
        updateSort(value, order) {
            this.$emit('apply-sort', value, order);
        }
    },
}
</script>

<style scoped>

</style>
